import { ESTADO_FLUJO } from "@/config/copiloto";

export const EstadoBadge = ({ estado, testid }) => {
  const s = ESTADO_FLUJO[estado] || ESTADO_FLUJO.borrador_ia;
  return (
    <span data-testid={testid} className={`inline-flex text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 rounded-full border ${s.cls}`}>
      {s.label}
    </span>
  );
};

export const JurBadge = ({ jur, referencia, testid }) => (
  <span data-testid={testid} className="inline-flex text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 rounded-full border bg-[#F3EFE6] text-slate-600 border-[#E2DCD2]">
    {referencia ? "Referencia CDMX" : jur}
  </span>
);
